module.exports = __webpack_public_path__ + "img/80e08a5.png";